import Service from "../../AuthService";
const RROrder = {
    getRROrder(page) {
        return Service.get("/rr-order?page="+page);
    },
    showRROrder(id) {
        return Service.get("/rr-order/"+id);
    },
    createRROrder(data) {
        return Service.post("/rr-order" ,data);
    },
    updateRROrder(id,data) {
        return Service.put("/rr-order/"+id ,data);
    },
    deleteRROrder(id){
        return Service.delete("/rr-order/"+id );
    },
    searchByVendor(vendor){
        return Service.get("/rr-vendor-search?vendor_id="+vendor)
    },
    search(page,data){
        return Service.post('/rr-order-search?page=' +page,data);
    },
    generateRR(date){
        return Service.get('generate_rr_number?date='+date)
    }
};
export default RROrder;
